// BSL-BLG §5 — Blog turları. Ekran başına en çok 3 balon, metin ≤ 140 karakter.
// Bir `data-tur` elemanı silinir/taşınırsa bu dosya aynı commit'te düzeltilir (çatı §12).
// `:id` içeren yol herhangi bir kimlikle eşleşir (yolEsit).
export default {
  blogYeni: {
    yol: "/blog/yeniyazi",
    adimlar: [
      { hedef: '[data-tur="blog-baslik"]', metin: "Başlık ve kısa giriş; giriş listede ve paylaşımlarda görünür." },
      { hedef: '[data-tur="blog-metin"]', metin: "Yazının gövdesi." },
      { hedef: '[data-tur="blog-durum"]', metin: "Taslak olarak kaydedin; hazır olunca Yayında'yı seçin. İleri tarih verirseniz o gün yayına çıkar.", kavram: "yayinDurumu" },
    ],
  },
  // İlk kayıttan sonra Düzenle ekranı açılınca bir kez kendiliğinden başlar (BlogYaziForm, bsl.sonTur).
  blogDuzenle: {
    yol: "/blog/duzenle/:id",
    adimlar: [
      { hedef: '[data-tur="blog-gorsel"]', bekle: true, metin: "Görseli ilk kayıttan sonra buradan ekleyin; ilk görsel kapak olur." },
      { hedef: '[data-tur="blog-slug"]', metin: "Yazının bağlantısı bu addan oluşur. Yayından sonra değiştirmeyin; eski bağlantı çalışmaz.", kavram: "kisaBaglanti" },
    ],
  },
  // BLG-YAYIN: Yazılar listesinde ilk taslağın «Yayınla» düğmesi.
  blogYayin: {
    yol: "/blog/yazilar",
    adimlar: [
      { hedef: '[data-tur="blog-yayinla"]', metin: "Taslağı buradan tek tıkla yayınlayın ya da açıp Durum'u Yayında yapın.", kavram: "yayinDurumu" },
      { hedef: '[data-tur="blog-yayinda"]', metin: "Yazı yayında ve bir koleksiyondaysa buradan sitedeki halini açarsınız.", kavram: "koleksiyon" },
    ],
  },
  blogKoleksiyon: {
    yol: "/blog/koleksiyonlar",
    adimlar: [
      { hedef: '[data-tur="koleksiyon-yeni"]', metin: "Yazılar sitede bir koleksiyonun sayfasında görünür.", kavram: "koleksiyon" },
      // Pencere açıksa «Yazı Seçimi» alanı, kapalıysa sayfadaki bilgi notu.
      { hedef: ['[data-tur="koleksiyon-secim"]', '[data-tur="koleksiyon-bilgi"]'], metin: "«Yayındaki tüm yazılar» seçerseniz yeni yazılar kendiliğinden eklenir." },
    ],
  },
  // Koleksiyon kaydedilince / «Örnekle başla» sonrası detay «Siteme Ekle» sekmesinde açılır.
  koleksiyonSiteme: {
    yol: "/blog/koleksiyon/:id",
    sekme: "2",
    adimlar: [
      { hedef: '[data-tur="koleksiyon-baglanti"]', metin: "Bu bağlantıyı paylaşın ya da menünüze ekleyin." },
      { hedef: '[data-tur="koleksiyon-gomme"]', metin: "Gömme kodunu sitenize yapıştırırsanız yazılar sitenizin içinde görünür." },
    ],
  },
};
